import * as types from './action-types'

export const dismissAlert = (id: string, dismissed_at: string) => ({
  type: types.DISMISSIBLE_ALERTS_DISMISS,
  id,
  dismissed_at,
})
